/**
 * @module findLastModifiedOnPage
 */
const { flattenObject } = require('./flattenObject');

/**
 * Convenience function to inspect the specified page data and return the last modified date.
 *
 * @param {object} pageData - The page data over which to inspect when finding the last modified date.
 * @param {boolean} isPageDataFlattened - Optional boolean flag denoting whether or not the provided data is already-flattened. This is useful for speed and performance optimization.
 *
 * @returns {string} The last modified, or most recent, date string from the specified page data.
 */
const findLastModifiedOnPage = (pageData, isPageDataFlattened) => {
  const lastModified = pageData?.['mgnl:lastModified'];
  if (lastModified) {
    return lastModified;
  }
  /**
   * Note: The ignore should not be necessary as the tests cover both for the
   * case of the isPageDataFlattened being set to true and default of false,
   * yet Jest is showing as uncovered because it is within the Object.entries().
   */
  const flatDates = Object.entries(
    /* istanbul ignore next */ isPageDataFlattened
      ? pageData
      : flattenObject(pageData),
  )
    .filter(([key]) => /modified$/.test(key.toLowerCase())) // NOSONAR
    .map(([, value]) => value);

  if (flatDates.length === 0) {
    return new Date();
  }

  let max_date = flatDates[0];
  let max_dtObj = new Date(flatDates[0]);
  flatDates.forEach((flatDate) => {
    if (new Date(flatDate) > max_dtObj) {
      max_date = flatDate;
      max_dtObj = new Date(flatDate);
    }
  });
  return max_date;
};

module.exports = {
  findLastModifiedOnPage,
};
